import { sva } from "../../styled-system/css";

export const progressStyles = sva({
  slots: ["label", "range", "root", "track", "valueText"],
  base: {
    range: {
      backgroundColor: "primary",
      borderRadius: "4px",
      height: "100%",
      transition: "width 0.2s ease-in-out",
    },
    label: {
      fontSize: "18px",
      fontWeight: 600,
      lineHeight: 1,
      textAlign: "center",
      textShadow: "0 0 4px white",
    },
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      maxWidth: "50%",
      width: "100%",
    },
    track: {
      backgroundColor: "background",
      borderRadius: "4px",
      height: "4px",
      overflow: "hidden",
    },
    valueText: {
      textAlign: "center",
      textShadow: "0 0 4px white",
    },
  },
});
